<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19.5 2h-15A4.5 4.5 0 0 0 0 6.5v8A4.5 4.5 0 0 0 4.5 19h7v2h-4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-4v-2h7a4.5 4.5 0 0 0 4.5-4.5v-8A4.5 4.5 0 0 0 19.5 2M23 14.5a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 1 14.5v-8A3.5 3.5 0 0 1 4.5 3h15A3.5 3.5 0 0 1 23 6.5z"/></svg>
</template>
